import React from 'react';
import PropTypes from 'prop-types';

const VARIANT_MAP = {
  h1: { tag: 'h1', size: '2.25rem' }, // 36px
  h2: { tag: 'h2', size: '1.5rem' }, // 24px
  h3: { tag: 'h3', size: '1.25rem' }, // 20px
  body1: { tag: 'p', size: '1rem' }, // 16px
  body2: { tag: 'p', size: '0.95rem' }, // 15px
  caption: { tag: 'span', size: '0.875rem' } // 14px
};

export default function Typography({
  variant = 'body1',
  color = 'inherit',
  align = 'left',
  bold = false,
  className = '',
  style = {},
  children,
  ...rest
}) {
  const v = VARIANT_MAP[variant] || VARIANT_MAP.body1;
  const Tag = v.tag;

  const combinedStyle = {
    color,
    textAlign: align,
    fontWeight: bold ? 700 : undefined,
    fontSize: v.size,
    ...style
  };

  return (
    <Tag className={className} style={combinedStyle} {...rest}>
      {children}
    </Tag>
  );
}

Typography.propTypes = {
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'body1', 'body2', 'caption']),
  color: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  bold: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};
